export * from './ng2-carouselamos';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /usr/src/app/src/app/ng2-carouselamos/dist/components/index.js
// module id = ../../../../../src/app/ng2-carouselamos/dist/components/index.js
// module chunks = main